import React from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import { tok, LABEL, weeks } from './clockUi';
import DepthBadge from '../DepthBadge';
import { SIDES } from './clockSide';

// The Cycle Clock's list (DWLF-301): markets on the dial ranked by how far through their cycle they
// are, then the ones with no reliable cycle or that failed to load.
export default function RankedList({ side = SIDES.low, ranked, offDial, focus, inFilter, onSelect }) {
  return (
    <Box>
      <Typography sx={{ ...LABEL, fontSize: '0.6875rem', color: tok('accent'), mb: 1 }}>{side.ranked}</Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        {ranked.filter(inFilter).map((m) => (
          <ButtonBase
            key={m.symbol}
            onClick={() => onSelect(m.symbol)}
            sx={{
              display: 'grid',
              // The badge track is fixed (the longest label, NOT REACHED) so every row's columns line up.
              gridTemplateColumns: { xs: 'minmax(56px, 1fr) minmax(0, 80px) 100px 44px', sm: 'minmax(0, 1fr) 170px 100px 90px' }, alignItems: 'center', gap: { xs: 1, sm: 1.5 }, minHeight: 44, px: 1.75,
              textAlign: 'left', backgroundColor: focus?.symbol === m.symbol ? tok('elevated') : tok('surface'),
              border: `1px solid ${focus?.symbol === m.symbol ? tok('accent') : tok('ink-08')}`,
            }}
          >
            <Typography component="span" sx={{ fontSize: '0.8125rem', color: tok('text') }}>{m.symbol}</Typography>
            <Box component="span" sx={{ ...LABEL, display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, fontSize: '0.625rem', color: tok(m.stage.token) }}>
              <Box component="span" sx={{ flexShrink: 0, width: 8, height: 8, backgroundColor: tok(m.stage.token) }} />
              {/* Truncated on a phone, where the track is narrow, rather than spilling into the depth badge. */}
              <Box component="span" sx={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.stage.label}</Box>
            </Box>
            <Box component="span"><DepthBadge depth={m.depth} side={m.side} hideEmpty focusable={false} /></Box>
            <Typography component="span" sx={{ justifySelf: 'end', fontSize: '0.6875rem', color: tok('ink-50') }}>
              wk {Math.round(m.weeksSincePivot)}/{weeks(m.typicalWeeks)}
            </Typography>
          </ButtonBase>
        ))}
      </Box>
      {['none', 'error'].map((key) => {
        const list = offDial.filter((m) => m.stage.key === key);
        if (!list.length) return null;
        return (
          <Typography key={key} sx={{ mt: 1.5, fontSize: '0.75rem', lineHeight: 1.6, color: tok('ink-50') }}>
            {key === 'none' ? 'No reliable weekly cycle yet' : "Couldn't load"}: {list.map((m) => m.symbol).join(', ')}.
          </Typography>
        );
      })}
    </Box>
  );
}
